export const MenuActionTypes = {
    API_RESPONSE_SUCCESS: '@@menu/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@menu/API_RESPONSE_ERROR',

    GET_MENU_LIST: '@@menu/GET_MENU_LIST',
};
